// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AUTOGENERIERT aus shared/variables.css — NICHT direkt editieren!
   Quelle ändern und ./scripts/sync-shared.sh ausführen. */
:root {
  --primary-dark: #848e5e;
  --primary-light: #dde8b9;
  --blutorange: #EE5622;
  --orange: #F39200;
  --gelb: #F4AF20;
  --blassgruen: #DDE8B9;
  --hellgruen: #C2D38B;
  --mittelgruen: #c1d38b;
  --dunkelgruen: #648202;
  --blassblau: #6DADD0;
  --hellblau: #0074B3;
  --mittelblau: #00509E;
  --weiss: #FFFFFF;
  --placeholder: #9fb05f;
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;0DAC0D;AAC1D;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB","sourcesContent":["/* AUTOGENERIERT aus shared/variables.css — NICHT direkt editieren!\n   Quelle ändern und ./scripts/sync-shared.sh ausführen. */\n:root {\n  --primary-dark: #848e5e;\n  --primary-light: #dde8b9;\n  --blutorange: #EE5622;\n  --orange: #F39200;\n  --gelb: #F4AF20;\n  --blassgruen: #DDE8B9;\n  --hellgruen: #C2D38B;\n  --mittelgruen: #c1d38b;\n  --dunkelgruen: #648202;\n  --blassblau: #6DADD0;\n  --hellblau: #0074B3;\n  --mittelblau: #00509E;\n  --weiss: #FFFFFF;\n  --placeholder: #9fb05f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
